<template>
    <div id="data-list-thumb-view" class="data-list-container">
      <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      @emitRefresh = "refresh"
      :data="sidebarData"
    />
    <vs-popup
      class="holamundo"
      title="İndirim Sebebi Sil"
      :active.sync="deletePopupActive"
      v-esc="escapeDelete"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu İndirim Sebebini Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          id="removeButton"
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteData(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
        <vs-table
        ref="table"
        :data="reasonList"
        v-model="selected"
        :class="{ 'no-pointer-rows': !$isCenterBranch() }">
        <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row
          id="panelHeaderRow"
          vs-type="flex"
          vs-w="12"
          vs-justify="space-between"
        >
          <vs-col
            id="panel-actions"
            vs-type="flex"
            class="w-auto"
            vs-justify="center"
          >
            <vs-row vs-type="flex" vs-w="12">
              <vs-col v-if="$isCenterBranch()" vs-type="flex" class="w-auto">
                <vx-tooltip text="Yeni İndirim Sebebi" position="top">
                  <vs-button
                    @click="addNewData"
                    class="panel-action text-success xlarge-button panel-action-box-shadow"
                    color="transparent"
                    icon-pack="feather"
                    icon="icon-plus"
                  >
                  </vs-button>
                </vx-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
        <template slot="thead">
          <vs-th class="w-9/12 justify-center">
            <vs-button
              icon-pack="feather"
              color="primary"
              type="flat"
              >İsim
            </vs-button>
          </vs-th>
          <vs-th class="w-3/12 justify-center" v-if="$isCenterBranch()">
            <vs-button
              icon-pack="feather"
              color="primary"
              type="flat"
              >İşlemler
            </vs-button>
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody class="text-center">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="w-5/12">
                <p class="font-medium truncate">{{ tr.name }}</p>
              </vs-td>
              <vs-td class="w-1/12 whitespace-no-wrap" v-if="$isCenterBranch()">
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="
                  deletedId = tr.id;
                  deletePopupActive = true;
                "
              />
            </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    </div>
</template>

<script>
  import { GetAllDiscountReason,Delete } from "@/api/DiscountReason.js";
  import DataViewSidebar from "./NewDiscountReason.vue";

export default {
  components: {
    DataViewSidebar
  },
data(){
return{
    reasonList:[],
    selected: "",
    addNewDataSidebar: false,
    sidebarData: {},
    selectedRoleName:'',
    deletePopupActive: false,
    deletedId: null,
}
},
methods:{
  escapeDelete() {
      if (this.deletePopupActive == true) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
  addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    getReasons(){
        var result = this.GetAllDiscountReason();
        console.log(result);
    },
    refresh: async function () {
      var result = await GetAllDiscountReason();
      this.reasonList = result.data;
    },
    deleteData: async function(id) {
      await Delete(id).then((res) => {
        if (res && res.status == 200) {
          this.$vs.notify({
              color: "success",
              title: "Silme İşlemi",
              text: "İndirim Sebebi Başarıyla Silindi",
            });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !",
          });
        }
      }).catch((error) => {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata !',
                  text: error.response.data.Errors[0].Message
                });
              });
              await this.refresh();
              this.deletePopupActive = false;
    },
    editData(data) {
        this.sidebarData = data;
        this.toggleDataSidebar(true);
      },
      toggleDataSidebar(val = false) {
        this.addNewDataSidebar = val;
        val == false ? (this.selected = null) : null;
      }
},
created: async function () {
    var result = await GetAllDiscountReason();
    this.reasonList = result.data;
},
watch:{
    selected: async function (val) {
       if (val!=null && this.$isCenterBranch()) {
        this.editData(val)
       }
     }
}
}
</script>

<style scoped>
.no-pointer-rows ::v-deep tbody tr {
  cursor: default !important;
  pointer-events: none !important;
}
</style>